import React from 'react';
import {
  withRouter,
  type WithRouterProps,
} from '@americanexpress/one-app-router';
import { useRouteParams } from '@/context/routeParamsContext';
import { isInvalidLoungeFinderRoute } from '@/helpers/utils';
import {
  TclMigrationFeatures,
  useTCLFeatureFlags,
} from '@/hooks/featureFlagHooks';
import {
  centurionNetworkPageRoute,
  culinaryCollectivePageRoute,
} from '@/constants/routes';
import { type RouteParams } from '@/types';
import NotFound from './NotFound';

type Props = {
  children: React.ReactNode;
} & Pick<WithRouterProps, 'routes'>;

const LoungeFinderErrorBoundary = ({ children, routes = [] }: Props) => {
  const { product, locale: routeLocale } = useRouteParams() as RouteParams;
  const isCenturionNetworkEnabled = useTCLFeatureFlags(
    TclMigrationFeatures.CENTURION_NETWORK_PAGE
  );
  const isCulinaryCollectiveEnabled = useTCLFeatureFlags(
    TclMigrationFeatures.CULINARY_COLLECTIVE_PAGE
  );
  const matchedRoutePath = routes[routes.length - 1]?.path;

  const isCenturionNetworkRoute =
    matchedRoutePath === centurionNetworkPageRoute && isCenturionNetworkEnabled;
  const isCulinaryCollectiveRoute =
    matchedRoutePath === culinaryCollectivePageRoute &&
    isCulinaryCollectiveEnabled;

  const shouldRender404 = isInvalidLoungeFinderRoute({
    locale: routeLocale,
    product,
  });

  if (
    shouldRender404 &&
    !isCenturionNetworkRoute &&
    !isCulinaryCollectiveRoute
  ) {
    return <NotFound />;
  }

  return children as React.ReactElement;
};

export default withRouter(LoungeFinderErrorBoundary);
